<template>
  <CatalogoPagina titulo="Productos" prefijo="productos" :resumen="resumen" :columnas="columnas"
    :total="total" :pagina="paginaActual" :total-paginas="totalPaginas" :limite="limite"
    :cargando="cargando" :ya-cargo="yaCargo" :error="errorCarga" mensaje-error="No pudimos cargar los productos."
    :orden-campo="ordenCampo" :orden-asc="ordenAsc" :aviso="aviso"
    @limite="alCambiarLimite" @ordenar="ordenarPor" @pagina="cambiarPagina" @reintentar="initialize" @cerrar-aviso="aviso = ''">
    <template #acciones>
      <button class="rm-btn rm-btn-primario" type="button" data-testid="productos-nuevo" @click="abrirFormulario(null)"><AppIcon name="plus" size="h-4 w-4" /> Nuevo producto</button>
    </template>
    <template #filtros>
      <AppBusqueda v-model="busqueda" placeholder="Buscar producto" testid="productos-buscar" @buscar="aplicarFiltros" />
      <button v-if="busqueda" type="button" class="cat-limpiar" @click="busqueda = ''; aplicarFiltros()">Limpiar búsqueda</button>
    </template>
    <template #filas>
      <tr v-for="producto in productos" :key="producto._id" data-testid="producto-fila">
        <td><div class="cat-pila"><span class="cat-nombre-texto">{{ producto.name }}</span><span class="cat-meta">{{ producto.code || 'Sin código' }} · {{ nombreReferencia(producto.brand) }}</span></div></td>
        <td class="producto-relaciones"><div class="cat-pila"><span>{{ nombreReferencia(producto.category) }}</span><span class="cat-meta">{{ nombreReferencia(producto.provider, 'company_name') }}</span></div></td>
        <td class="producto-importe"><span class="producto-etiqueta">Compra: </span>{{ dinero(producto.purchase_price) }}</td>
        <td class="producto-importe"><span class="producto-etiqueta">Venta: </span>{{ dinero(producto.sale_price) }}</td>
        <td class="cat-fila-acciones">
          <button class="cat-icono-btn" type="button" :aria-label="'Ver detalle de ' + producto.name" data-testid="producto-detalle" @click="abrirDetalle(producto)"><AppIcon name="eye" size="h-4 w-4" /></button>
          <button class="cat-icono-btn" type="button" :aria-label="'Editar ' + producto.name" data-testid="producto-editar" @click="abrirFormulario(producto)"><AppIcon name="pencil" size="h-4 w-4" /></button>
          <button class="cat-icono-btn peligro" type="button" :aria-label="'Dar de baja ' + producto.name" data-testid="producto-eliminar" @click="pedirEliminar(producto)"><AppIcon name="trash" size="h-4 w-4" /></button>
        </td>
      </tr>
    </template>
    <template #vacio><p>{{ busqueda.trim() ? 'No hay productos que coincidan con la búsqueda.' : 'Aún no hay productos.' }}</p></template>
    <BaseModal :visible="dialogoForm" :title="seleccionado ? 'Editar producto' : 'Nuevo producto'" max-width="max-w-[720px]" persistent @close="cerrarFormulario">
      <p v-if="errorFormulario" role="alert" class="producto-error" data-testid="producto-error-guardar">{{ errorFormulario }}</p>
      <p v-if="cargandoOpciones" role="status">Cargando opciones…</p>
      <div v-if="errorOpciones" role="alert" class="producto-error">No pudimos cargar las opciones. <button type="button" @click="cargarOpciones">Reintentar opciones</button></div>
      <form class="producto-form" novalidate data-testid="producto-form" @submit.prevent="guardar">
        <AppField v-model="form.name" label="Nombre" required uppercase :error="errorCampo('name')" testid="producto-nombre" @blur="tocar('name')" />
        <AppField v-model="form.code_bar" label="Código de barras" uppercase testid="producto-barras" />
        <AppField v-model="form.description" class="producto-ancho" label="Descripción" uppercase testid="producto-descripcion" />
        <AppField v-for="campo in referencias" :key="campo.key" v-slot="{ controlId }" :label="campo.label" required :error="errorCampo(campo.key)" :testid="'producto-' + campo.key">
          <AppCombobox :id="controlId" v-model="form[campo.key]" :options="opcionesDe(campo)" :placeholder="campo.placeholder" :invalid="Boolean(errorCampo(campo.key))" :describedby="errorCampo(campo.key) ? controlId + '-error' : null" :testid="'producto-' + campo.key" @blur="tocar(campo.key)" />
        </AppField>
        <AppField v-model="form.purchase_price" label="Precio de compra" type="number" min="0" inputmode="decimal" required :error="errorCampo('purchase_price')" testid="producto-compra" @blur="tocar('purchase_price')" />
        <AppField v-model="form.sale_price" label="Precio de venta" type="number" min="0" inputmode="decimal" required :error="errorCampo('sale_price')" testid="producto-venta" @blur="tocar('sale_price')" />
        <AppField v-model="form.code_sat" label="Código SAT" maxlength="8" uppercase testid="producto-sat" />
        <AppField v-slot="{ controlId }" label="Unidad de medida SAT">
          <AppCombobox :id="controlId" v-model="form.clave_unidad_sat" :options="opcionesUnidad" placeholder="Busca una unidad" testid="producto-unidad" />
        </AppField>
      </form>
      <template #footer>
        <button type="button" class="rm-btn rm-btn-secundario" :disabled="guardando" @click="cerrarFormulario">Cancelar</button>
        <button type="button" class="rm-btn rm-btn-primario" :disabled="guardando || cargandoOpciones || Boolean(errorOpciones)" data-testid="producto-guardar" @click="guardar">{{ guardando ? 'Guardando…' : 'Guardar' }}</button>
      </template>
    </BaseModal>
    <BaseModal :visible="dialogoEliminar" title="Dar de baja producto" @close="cerrarEliminar">
      <p class="cat-confirmacion">¿Dar de baja a <b>{{ seleccionado && seleccionado.name }}</b>? La baja puede rechazarse si el producto tiene existencias.</p>
      <p v-if="errorFormulario" role="alert" class="producto-error" data-testid="producto-error-baja">{{ errorFormulario }}</p>
      <template #footer>
        <button type="button" class="rm-btn rm-btn-secundario" :disabled="guardando" @click="cerrarEliminar">Cancelar</button>
        <button type="button" class="rm-btn rm-btn-peligro" :disabled="guardando" data-testid="producto-confirmar-eliminar" @click="confirmarEliminar">{{ guardando ? 'Dando de baja…' : 'Dar de baja' }}</button>
      </template>
    </BaseModal>
    <BaseModal :visible="Boolean(detalle)" title="Detalle de producto" max-width="max-w-[720px]" @close="detalle = null">
      <dl v-if="detalle" class="producto-detalle" data-testid="producto-detalle-datos">
        <template v-for="dato in datosDetalle"><dt :key="dato.label + '-etiqueta'">{{ dato.label }}</dt><dd :key="dato.label">{{ dato.value }}</dd></template>
      </dl>
    </BaseModal>
  </CatalogoPagina>
</template>

<script>
import Catalogos from '@/services/catalogos'
import ApiService from '@/services/apis'
import CatalogoPagina, { LIMITE_BASE } from '@/components/catalogo/CatalogoPagina.vue'
import AppBusqueda from '@/components/ui/AppBusqueda.vue'
import AppCombobox from '@/components/ui/AppCombobox.vue'
import AppField from '@/components/ui/AppField.vue'
import AppIcon from '@/components/ui/AppIcon.vue'
import BaseModal from '@/components/ui/BaseModal.vue'
import { paginaEquivalente } from '@/utils/paginacion'

const campos = ['name', 'description', 'code_bar', 'category', 'provider', 'brand', 'purchase_price', 'sale_price', 'code_sat', 'clave_unidad_sat']
const vacio = () => Object.fromEntries(campos.map(campo => [campo, '']))
const idDe = valor => valor && typeof valor === 'object' ? valor._id : valor || ''
const motivo = (error, fallback) => error?.response?.data?.message || error?.data?.message || (typeof error?.response?.data === 'string' ? error.response.data : '') || (typeof error?.data === 'string' ? error.data : '') || fallback

export default {
  name: 'Productos',
  components: { CatalogoPagina, AppBusqueda, AppCombobox, AppField, AppIcon, BaseModal },
  data() {
    return {
      productos: [], total: 0, totalPaginas: 1, paginaActual: 1, limite: LIMITE_BASE,
      busqueda: '', ordenCampo: 'name', ordenAsc: true, cargando: true, yaCargo: false, errorCarga: false,
      dialogoForm: false, dialogoEliminar: false, seleccionado: null, detalle: null, form: vacio(),
      guardando: false, intentoGuardar: false, tocados: {}, errorFormulario: '', aviso: '',
      opciones: { category: [], provider: [], brand: [] }, unidades: [], cargandoOpciones: false, errorOpciones: false,
      // Con buscador, como el v-autocomplete del sistema anterior: en un <select> no se puede escribir
      referencias: [{ key: 'category', label: 'Categoría', text: 'name', placeholder: 'Busca una categoría' }, { key: 'provider', label: 'Proveedor', text: 'company_name', placeholder: 'Busca un proveedor' }, { key: 'brand', label: 'Marca', text: 'name', placeholder: 'Busca una marca' }],
      columnas: [{ value: 'name', label: 'Producto' }, { value: 'referencias', label: 'Categoría y proveedor', ordenable: false }, { value: 'purchase_price', label: 'Compra', alinear: 'derecha', ancho: '120px' }, { value: 'sale_price', label: 'Venta', alinear: 'derecha', ancho: '120px' }],
    }
  },
  computed: {
    resumen() { return `${this.total} ${this.busqueda.trim() ? 'coincidencias' : 'productos activos'}` },
    errores() {
      const errores = {}
      for (const campo of ['name', 'category', 'provider', 'brand']) if (!String(this.form[campo]).trim()) errores[campo] = 'Requerido.'
      for (const campo of ['purchase_price', 'sale_price']) {
        const valor = this.form[campo]
        // Conservar truthiness legada: 0 numérico vacío; "0" textual presente.
        if (!valor) errores[campo] = 'Requerido.'
        else if (!Number.isFinite(Number(valor)) || Number(valor) < 0) errores[campo] = 'Debe ser un importe no negativo.'
      }
      return errores
    },
    datosDetalle() {
      const p = this.detalle || {}
      return [{ label: 'Nombre', value: p.name }, { label: 'Código', value: p.code }, { label: 'Código de barras', value: p.code_bar }, { label: 'Descripción', value: p.description }, { label: 'Categoría', value: this.nombreReferencia(p.category) }, { label: 'Proveedor', value: this.nombreReferencia(p.provider, 'company_name') }, { label: 'Marca', value: this.nombreReferencia(p.brand) }, { label: 'Precio de compra', value: this.dinero(p.purchase_price) }, { label: 'Precio de venta', value: this.dinero(p.sale_price) }, { label: 'Código SAT', value: p.code_sat }, { label: 'Unidad SAT', value: p.clave_unidad_sat }].map(d => ({ ...d, value: d.value ?? 'Sin dato' }))
    },
    opcionesUnidad() {
      const actual = this.form.clave_unidad_sat
      const opciones = this.unidades.map(u => ({ value: u.clave, label: u.nombre, codigo: String(u.clave) }))
      const desconocida = actual && !opciones.some(o => o.value === actual) ? [{ value: actual, label: actual }] : []
      return [{ value: '', label: 'Sin unidad' }, ...desconocida, ...opciones]
    },
  },
  created() { this.ultimaConsulta = 0; this.limiteListo = false },
  beforeDestroy() { this.ultimaConsulta++; clearTimeout(this.avisoTimer) },
  methods: {
    dinero(valor) { return valor === null || valor === undefined || valor === '' || !Number.isFinite(Number(valor)) ? 'Sin dato' : new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(valor)) },
    nombreReferencia(valor, campo = 'name') { return valor && typeof valor === 'object' ? valor[campo] || 'Sin dato' : valor || 'Sin dato' },
    async initialize() {
      const consulta = ++this.ultimaConsulta
      this.cargando = true; this.errorCarga = false
      try {
        const res = await Catalogos.productoPaginado({ pagina: this.paginaActual, limite: this.limite, busqueda: this.busqueda.trim(), ordenarPor: this.ordenCampo, direccion: this.ordenAsc ? 'asc' : 'desc' })
        if (consulta !== this.ultimaConsulta) return
        if (!Array.isArray(res?.productos)) throw new Error('Respuesta inválida')
        this.productos = res.productos; this.total = Number(res.total) || 0; this.totalPaginas = Math.max(1, Number(res.totalPages) || 1); this.yaCargo = true
        if (this.paginaActual > this.totalPaginas) { this.paginaActual = this.totalPaginas; return this.initialize() }
      } catch (error) {
        if (consulta !== this.ultimaConsulta) return
        this.errorCarga = true; this.yaCargo = false
      } finally { if (consulta === this.ultimaConsulta) this.cargando = false }
    },
    alCambiarLimite(nuevo) {
      if (!this.limiteListo) { this.limiteListo = true; this.limite = nuevo; return this.initialize() }
      if (nuevo === this.limite) return
      this.paginaActual = paginaEquivalente(this.paginaActual, this.limite, nuevo); this.limite = nuevo; this.initialize()
    },
    aplicarFiltros() { this.paginaActual = 1; this.initialize() },
    ordenarPor(campo) {
      if (!['name', 'code', 'sale_price', 'purchase_price'].includes(campo)) return
      this.ordenAsc = campo === this.ordenCampo ? !this.ordenAsc : true; this.ordenCampo = campo; this.aplicarFiltros()
    },
    cambiarPagina(pagina) { if (pagina < 1 || pagina > this.totalPaginas || pagina === this.paginaActual) return; this.paginaActual = pagina; this.initialize() },
    async cargarOpciones() {
      if (this.cargandoOpciones) return
      this.cargandoOpciones = true; this.errorOpciones = false
      try {
        const [categoria, proveedor, marca, unidades] = await Promise.all([ApiService.categoria(), ApiService.proveedor(), ApiService.marcaByFilter({ type: 1 }), ApiService.UnidadMedida()])
        if (![categoria?.data, proveedor?.data, marca?.data, unidades].every(Array.isArray)) throw new Error('Opciones inválidas')
        this.opciones = { category: categoria.data, provider: proveedor.data, brand: marca.data }; this.unidades = unidades
      } catch (error) { this.errorOpciones = true } finally { this.cargandoOpciones = false }
    },
    opcionesConActual(campo) {
      const lista = this.opciones[campo]
      const actual = this.seleccionado?.[campo]
      if (actual && typeof actual === 'object' && !lista.some(o => o._id === actual._id)) return [...lista, actual]
      if (this.form[campo] && !lista.some(o => o._id === this.form[campo])) return [...lista, { _id: this.form[campo], name: this.form[campo], company_name: this.form[campo] }]
      return lista
    },
    opcionesDe(campo) { return this.opcionesConActual(campo.key).map(o => ({ value: o._id, label: o[campo.text] || 'Sin nombre' })) },
    abrirFormulario(producto) {
      this.seleccionado = producto
      this.form = vacio()
      if (producto) campos.forEach(campo => { this.form[campo] = ['category', 'provider', 'brand'].includes(campo) ? idDe(producto[campo]) : producto[campo] ?? '' })
      this.tocados = {}; this.intentoGuardar = false; this.errorFormulario = ''; this.dialogoForm = true; this.cargarOpciones()
    },
    cerrarFormulario() { if (this.guardando) return; this.dialogoForm = false; this.seleccionado = null },
    tocar(campo) { this.tocados = { ...this.tocados, [campo]: true } },
    errorCampo(campo) { return this.intentoGuardar || this.tocados[campo] ? this.errores[campo] || '' : '' },
    async guardar() {
      this.intentoGuardar = true
      if (this.guardando || this.cargandoOpciones || this.errorOpciones) return
      if (Object.keys(this.errores).length) {
        await this.$nextTick()
        this.$el.querySelector('[data-testid="producto-form"] [aria-invalid="true"]')?.focus()
        return
      }
      const payload = { ...this.form }
      for (const campo of ['name', 'description', 'code_bar', 'code_sat']) payload[campo] = String(payload[campo]).trim().toUpperCase()
      this.guardando = true; this.errorFormulario = ''
      try {
        if (this.seleccionado) await Catalogos.productoEditar(this.seleccionado._id, payload)
        else await Catalogos.productoNuevo(payload)
        this.dialogoForm = false; this.seleccionado = null; await this.initialize(); this.mostrarAviso('Producto guardado')
      } catch (error) { this.errorFormulario = motivo(error, 'No pudimos guardar el producto. Reintenta sin perder los datos.') } finally { this.guardando = false }
    },
    pedirEliminar(producto) { this.seleccionado = producto; this.errorFormulario = ''; this.dialogoEliminar = true },
    cerrarEliminar() { if (this.guardando) return; this.dialogoEliminar = false; this.seleccionado = null },
    async confirmarEliminar() {
      if (this.guardando || !this.seleccionado) return
      this.guardando = true; this.errorFormulario = ''
      try {
        await Catalogos.productoEditar(this.seleccionado._id, { status: 0 })
        this.dialogoEliminar = false; this.seleccionado = null
        if (this.productos.length === 1 && this.paginaActual > 1) this.paginaActual--
        await this.initialize(); this.mostrarAviso('Producto dado de baja')
      } catch (error) { this.errorFormulario = motivo(error, 'No pudimos dar de baja el producto. Verifica sus existencias y reintenta.') } finally { this.guardando = false }
    },
    abrirDetalle(producto) { this.detalle = producto },
    mostrarAviso(texto) { this.aviso = texto; clearTimeout(this.avisoTimer); this.avisoTimer = setTimeout(() => { this.aviso = '' }, 4500) },
  },
}
</script>

<style scoped>
.cat-pagina ::v-deep .cat-tarjeta { --cat-alto-fila: 68px; }
.producto-form { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
.producto-ancho { grid-column: 1 / -1; }
.producto-error { color: #b91c1c; margin-bottom: 14px; }
.producto-error button { min-height: 44px; text-decoration: underline; }
.producto-detalle { display: grid; grid-template-columns: minmax(100px, 1fr) minmax(0, 2fr); gap: 12px; }
.producto-detalle dt { color: #607187; }
.producto-detalle dd { margin: 0; overflow-wrap: anywhere; }
.cat-pagina .cat-tabla td.producto-importe { text-align: right; font-variant-numeric: tabular-nums; }
.producto-etiqueta { display: none; }
.cat-pagina ::v-deep .cat-tabla th:last-child { width: 172px; }
.cat-pagina .cat-icono-btn { width: 44px; height: 44px; }
@media (pointer: coarse) { .cat-pagina ::v-deep .cat-th-btn { min-height: 44px; } }
@media (max-width: 700px) {
  .producto-form { grid-template-columns: minmax(0, 1fr); }
  .producto-etiqueta { display: inline; }
  .cat-pagina .cat-tabla td.producto-importe { text-align: left; }
  .cat-pagina .cat-tabla td.cat-fila-acciones { flex-wrap: wrap; width: 106px; gap: 6px; }
}
</style>
